// Components==============
import React from 'react';
import { DropdownType, TranslateType } from 'typings';
import ActivityDropdown from './ActivityDropdown';
import CategoryDropdown from './CategoryDropdown';
import PublicationDropdown from './PublicationDropdown';
import SkillDropdown from './SkillDropdow';
import SortDropdown from './SortDropdown';
import ProjectSourceDropdown from './ProjectSourceDropdown';
// =========================

export default function ConditionalDropdown({
  dropdownType,
  id,
  options,
  initialText,
}: {
  dropdownType?: DropdownType;
  id: number;
  options?: string[];
  initialText: TranslateType;
}) {
  if (dropdownType === 'skill')
    return <SkillDropdown initialText={initialText} id={id} />;

  if (dropdownType === 'category')
    return <CategoryDropdown initialText={initialText} id={id} />;

  if (dropdownType === 'activity')
    return <ActivityDropdown initialText={initialText} id={id} />;

  if (dropdownType === 'publication')
    return (
      <PublicationDropdown
        initialText={initialText}
        id={id}
        extraOptions={options}
      />
    );

  if (dropdownType === 'source')
    return <ProjectSourceDropdown initialText={initialText} id={id} />;

  if (dropdownType === 'sort')
    return <SortDropdown initialText={initialText} id={id} />;

  return <></>;
}
